export class SigningSessionUtil {
  static formatClock(totalSeconds: number): string {
    const safe = Math.max(0, Math.floor(totalSeconds));
    const hours = Math.floor(safe / 3600);
    const minutes = String(Math.floor((safe % 3600) / 60)).padStart(2, '0');
    const seconds = String(safe % 60).padStart(2, '0');
    return hours > 0 ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
  }

  static maskPhone(phone: string | undefined | null): string {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, '');
    return `•••• ${digits.slice(-4)}`;
  }

  static shortId(id: string): string {
    return `SES-${id.slice(-6).toUpperCase()}`;
  }
}
